// extracted by mini-css-extract-plugin
export var askAiIcon = "_q6-9";
export var container = "_q6-0";
export var groupSeparator = "_q6-a";
export var highlight = "_q6-4";
export var resultIcon = "_q6-5";
export var resultItem = "_q6-7";
export var resultSubtitle = "_q6-3";
export var resultTitle = "_q6-2";
export var resultsList = "_q6-1";
export var searchGroup = "_q6-6";
export var selected = "_q6-8";